import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {RouteName} from '../../router/route-names';
import {ILoginStore, LoginStore} from './login.stores';
// @ts-ignore
import {getSubDomainFromUrl} from '@techsee/techsee-common/lib/utils';

const trace = getAppTracer('login.loader');
export const MULTI_USER_LOGIN_CONTEXT_KEY = 'multiUserLoginContext';

export async function loginRouteLoader(args: LoaderFunctionArgs): Promise<ILoginStore> {
    trace.info('Starting');
    try {
        const rootStore = getRootStore();
        const url = new URL(args.request.url);
        const params = url.searchParams;
        const nav = rootStore.tsReactStateHelper;
        // Extract all URL parameters
        const urlParams = {
            authId: params.get('authId'),
            r: params.get('r'),
            p: params.get('p'),
            c: params.get('c'),
            is: params.get('is'),
            roomId: params.get('roomId'),
            g: params.get('g'),
            roomCode: params.get('roomCode'),
            nl: params.get('nl'),
            ott: params.get('ott'),
            audio: params.get('audio'),
            observe: params.get('observe'),
            emb: params.get('emb'),
            mini: params.get('mini'),
            tablet: params.get('tablet'),
            sw: params.get('sw'),
            prg: params.get('prg'),
            startDate: params.get('startDate'),
            endDate: params.get('endDate'),
            sophieCtx: params.get('sophie-ctx')
        };

        // 1. GUEST FLOW CHECK
        if (urlParams.observe === 'guest') {
            trace.info('Guest access detected, redirecting to guest');
            const {r, p, c, is, roomId, g, roomCode, audio, observe, emb, mini, ott, sw} = urlParams;

            await nav.navigateTo(RouteName.GUEST, {
                r,
                p,
                c,
                is,
                roomId,
                g,
                roomCode,
                audio,
                observe,
                emb,
                mini,
                ott,
                sw
            });
        }

        // 2. TABLET DETECTION & DISPLAY MODE
        const displayTabletAsDesktop = rootStore.displayTabletAsDesktop;
        const isTablet = rootStore.environmentService.isTablet(displayTabletAsDesktop);

        if ((urlParams.tablet || isTablet) && !displayTabletAsDesktop) {
            trace.info('Tablet detected, setting displayTabletAsDesktop and reloading');
            rootStore.browserUtilsService.saveToLocalStorage('displayTabletAsDesktop', true);
            window.location.reload();

            return new LoginStore();
        }

        // 3. EMBEDDED DASHBOARD CHECK
        const miniDashboard = rootStore.browserUtilsService.getFromSessionStorage('miniDashboard');
        if (miniDashboard) {
            trace.info('Mini dashboard detected, redirecting to error');
            await nav.navigateTo(RouteName.EMB_DASHBOARD_ERROR);
        }

        // 4. MANUAL LOGIN ABILITY ASSERTION
        const subDomain = getSubDomainFromUrl(window.location.href);
        try {
            const assertion = await rootStore.accountService.manualLoginAbilityAssertion(subDomain);

            if (assertion?.enabledLive3) {
                trace.info('Live3 enabled, redirecting to portal');
                rootStore.redirectionService.goToPortal();
                return new LoginStore();
            }

            if (!assertion?.enabled && assertion?.redirectUrl) {
                trace.info('Manual login disabled, external redirect', {url: assertion.redirectUrl});
                window.location.href = assertion.redirectUrl;
                return new LoginStore();
            }
        } catch (err) {
            if (err instanceof Response) throw err;
            trace.error('Manual login assertion failed', {error: err});
        }
    } catch (e) {
        if (e instanceof Response) throw e;
        trace.error('Failed to Load login - loader', e);
    }

    // 5. CREATE STORE
    const store = new LoginStore();

    trace.info('Completed successfully');
    return store;
}
